// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Router from "next/router";
import * as ReactModal from "react-modal";
import * as NextImage$PorterinFeature from "./NextImage.mjs";
import * as AssetStore$PorterinFeature from "../assets/AssetStore.mjs";
import * as FareEstimateVm$PorterinFeature from "../../shared/lead-flow/view/view-model/FareEstimateVm.mjs";
import * as FareEstimateStoreV1$PorterinFeature from "../../containers/fare-estimate-v1/domain/store/FareEstimateStoreV1.mjs";
import * as FareEstimateErrorCmp$PorterinFeature from "../../shared/lead-flow/view/component/FareEstimateErrorCmp.mjs";
import * as FareEstimateContextV1$PorterinFeature from "../../contexts/fare-estimate-context/FareEstimateContextV1.mjs";
import * as FareEstimateRetryHook$PorterinFeature from "../../shared/fare-estimate/view/hooks/FareEstimateRetryHook.mjs";
import * as BookingDetailsModuleScss from "@porterin/feature/src/ui/styles/common/BookingDetails.module.scss";

function ErrorModal(Props) {
  var modal_state = Props.modal_state;
  var close_modal = Props.close_modal;
  var error = Props.error;
  var error_source = Props.error_source;
  var toggle_booking_pickup = Props.toggle_booking_pickup;
  var toggle_booking_dropoff = Props.toggle_booking_dropoff;
  var match = Router.useRouter();
  var locale = match.locale;
  var fare_estimate_context = FareEstimateContextV1$PorterinFeature.useFareEstimateContext(undefined);
  var invalidPickupHandler = function (param) {
    if (error_source === 2 || error_source === 1) {
      return Curry._1(close_modal, undefined);
    } else {
      return Curry._1(toggle_booking_pickup, undefined);
    }
  };
  var invalidDropHandler = function (param) {
    if (error_source === 2 || error_source === 1) {
      return Curry._1(close_modal, undefined);
    } else {
      return Curry._1(toggle_booking_dropoff, undefined);
    }
  };
  var getErrorMessage = function (error) {
    if (error >= 3) {
      return FareEstimateVm$PorterinFeature.getErrorUnserviceableDropoff(locale);
    }
    switch (error) {
      case /* InvalidPickup */1 :
          return FareEstimateVm$PorterinFeature.getErrorUnserviceablePickup(locale);
      case /* InvalidToken */0 :
      case /* InvalidDrop */2 :
          return FareEstimateVm$PorterinFeature.getErrorUnserviceableDropoff(locale);
      
    }
  };
  var getButtonLabel = function (error) {
    if (error >= 3) {
      return FareEstimateVm$PorterinFeature.getDropOffButtonLabel(locale);
    }
    switch (error) {
      case /* InvalidPickup */1 :
          return FareEstimateVm$PorterinFeature.getPickupButtonLabel(locale);
      case /* InvalidToken */0 :
      case /* InvalidDrop */2 :
          return FareEstimateVm$PorterinFeature.getDropOffButtonLabel(locale);
      
    }
  };
  FareEstimateRetryHook$PorterinFeature.useHook(undefined);
  var tmp;
  var exit = 0;
  switch (error) {
    case /* InvalidToken */0 :
        tmp = React.createElement(FareEstimateErrorCmp$PorterinFeature.make, {
              image: FareEstimateVm$PorterinFeature.error_something_went_wrong,
              content: FareEstimateVm$PorterinFeature.error_something_wrong,
              button_text: FareEstimateStoreV1$PorterinFeature.error_something_wrong_button,
              button_action: (function (param) {
                  Curry._1(fare_estimate_context.set_is_retry, true);
                })
            });
        break;
    case /* InvalidPickup */1 :
        tmp = React.createElement(FareEstimateErrorCmp$PorterinFeature.make, {
              image: FareEstimateVm$PorterinFeature.error_invalid_location,
              content: getErrorMessage(error),
              button_text: getButtonLabel(error),
              button_action: invalidPickupHandler
            });
        break;
    case /* InvalidDrop */2 :
        tmp = React.createElement(FareEstimateErrorCmp$PorterinFeature.make, {
              image: FareEstimateVm$PorterinFeature.error_invalid_location,
              content: getErrorMessage(error),
              button_text: getButtonLabel(error),
              button_action: invalidDropHandler
            });
        break;
    case /* FailedAPI */3 :
    case /* FailedCreateTrip */4 :
        exit = 1;
        break;
    
  }
  if (exit === 1) {
    tmp = React.createElement(FareEstimateErrorCmp$PorterinFeature.make, {
          image: FareEstimateVm$PorterinFeature.error_something_went_wrong,
          content: FareEstimateVm$PorterinFeature.error_something_wrong,
          button_text: FareEstimateStoreV1$PorterinFeature.error_something_wrong_button,
          button_action: (function (param) {
              Curry._1(close_modal, undefined);
            })
        });
  }
  return React.createElement(ReactModal, {
              isOpen: modal_state,
              onRequestClose: close_modal,
              closeTimeoutMS: 0,
              overlayClassName: BookingDetailsModuleScss.overlay,
              className: BookingDetailsModuleScss["modal-container"],
              ariaHideApp: false,
              shouldCloseOnOverlayClick: true,
              children: React.createElement("div", {
                    className: BookingDetailsModuleScss["error-modal"]
                  }, React.createElement("div", {
                        className: BookingDetailsModuleScss.close,
                        onClick: (function (param) {
                            Curry._1(close_modal, undefined);
                          })
                      }, React.createElement(NextImage$PorterinFeature.make, {
                            src: AssetStore$PorterinFeature.crossIcon,
                            height: 16.0,
                            width: 16.0,
                            quality: 100.0,
                            alt: "Close"
                          })), tmp)
            });
}

var make = ErrorModal;

export {
  make ,
}
/* react Not a pure module */
